import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Routes under `/cms/card-schemas/*` (see `CmsApp.tsx` + `cms-shell-layout.tsx`).
 */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from 'shared/ui/error-boundary';
import CardSchemasPage from 'pages/card-schemas.page';
const CardSchemaRoutes = () => (_jsx(Routes, { children: _jsx(Route, { path: "*", element: _jsx(ErrorBoundary, { children: _jsx(CardSchemasPage, {}) }) }) }));
/** Registered in `features/index.ts` for shell nav and router. */
export const CMS_NAV_ITEM = {
    id: 'card-schemas',
    pathSegment: 'card-schemas',
    labelKey: 'form.cardSchema',
    icon: 'pi pi-id-card',
    authorityKeys: ['ADMIN'],
    RoutesComponent: CardSchemaRoutes,
};
export default CardSchemaRoutes;
